module.exports = __webpack_public_path__ + "assets/img/deposit.814593b2.svg";